import dayjs, { type Dayjs } from 'dayjs'

import useUser from '@/legacy-src/hooks/useUser'

const DEFAULT_CANCELLATION_WINDOW_HOURS = 24

export const useCancellationWindowHours = () => {
  const { user } = useUser()

  // Anonymous visitors (e.g. a public therapist profile) get the default window.
  const cancellationWindowHours = user?.cancellationWindowHours ?? DEFAULT_CANCELLATION_WINDOW_HOURS

  return {
    cancellationWindowHours,
    getIsWithinCancellationWindow: (startDate: string | Dayjs) =>
      !dayjs().add(cancellationWindowHours, 'hours').isBefore(dayjs(startDate)),
  }
}
